let messagesCache = {};

export const getMessagesCache = () => messagesCache;

export const setMessagesCache = (locale, messages) => {
    messagesCache[locale] = messages;
};

export const clearMessagesCache = () => {
    messagesCache = {};
};
